import React from 'react';

import { routes } from '@aline/routes';
import { Helmet } from 'react-helmet';
import { Route, Routes } from 'react-router-dom';
import { Group, GroupsList } from 'src/components/admin';
import { createRelativeRouter } from 'src/helpers/router-helpers';

const { toRelativePath: toRelativeGroupsPath } = createRelativeRouter(routes.AdminGroupIndex, {
  nestedRoutes: true,
});

export function GroupsPage(): JSX.Element {
  return (
    <>
      <Helmet>
        <title>Group Admin</title>
      </Helmet>
      <Routes>
        <Route element={<GroupsList />} path={toRelativeGroupsPath(routes.AdminGroupIndex)} />
        <Route element={<Group />} path={toRelativeGroupsPath(routes.AdminGroupDetail)} />
      </Routes>
    </>
  );
}
